export function dataParaIso(valor) {
    if (!valor) return null;
    if (valor instanceof Date && !Number.isNaN(valor.getTime())) {
        return valor.toISOString().substring(0, 10);
    }
    const texto = String(valor).substring(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(texto) ? texto : null;
}
